/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Pricing_DescriptionInputs */

const en_seo_pricing_description = /** @type {(inputs: Seo_Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete Athlete plans and prices for personal trainers, teams and clubs.`)
};

const pl_seo_pricing_description = /** @type {(inputs: Seo_Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plany i ceny Complete Athlete dla trenerów personalnych, zespołów i klubów.`)
};

/**
* | output |
* | --- |
* | "Complete Athlete plans and prices for personal trainers, teams and clubs." |
*
* @param {Seo_Pricing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_pricing_description = /** @type {((inputs?: Seo_Pricing_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Pricing_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_pricing_description(inputs)
	return en_seo_pricing_description(inputs)
});